import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';

@Injectable({
	providedIn: 'root'
})
export class TransationReceiptService extends BaseProvider {
	workingInvoice: any = [];

	costs: any = { costs: [] };
	feeAmount: any = [];
	additionalInfo: any = [];
	initialPaymentDetails: any = [];

	constructor(
		public translate: TranslateService,
		public globals: GlobalsService,
		public http: HttpClient,
	) {
		super();

		this.baseUrl = 'userProcessInvoice';
		this.translate
			.get(['payment.convenienceFee'])
			.subscribe(translations => {
				this.feeAmount = [
					{
						id: 1,
						name: 'costs.convenienceFee',
						cost: 0,
					}
				];
			});
	}

	getInvoiceById(id) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/' + id;

			this.http
				.get(this.url)
				.subscribe(
					(data: any) => {
						if (data.Data.length > 0) {
							this.workingInvoice = data.Data[0];
							this.additionalInfo = JSON.parse(this.workingInvoice.AdditionalInfo);
							this.manageCosts();

							resolve(data.Data);
						} else {
							resolve(null);
						}
					},
					err => { reject(err); }
				);
		});
	}

	getInitialPaymentDetails(invoiceId) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + `/processType/InitialPayment/${invoiceId}`;

			this.http
				.get(this.url)
				.subscribe(
					(data: any) => {

						this.initialPaymentDetails = data.Data;
						resolve(this.initialPaymentDetails);

					},
					err => { reject(err); }
				);
		});
	}

	manageCosts() {
		if (this.workingInvoice.CostJson) {
			this.costs = JSON.parse(this.workingInvoice.CostJson);
			this.feeAmount[0].cost = this.workingInvoice.FeeAmount;
			if (this.costs.costs) {
				this.costs.costs[this.costs.costs.length] = this.feeAmount[0];
				for (let i = 0; i < this.costs.costs.length; i++) {
					this.workingInvoice.Costs.push(this.costs.costs[i]);
					this.workingInvoice.Costs[i].Qty = 1;
				}
			}

		}
		// else{
		// 	this.workingInvoice.Costs.push({
		// 		"CostDescription": "costs.convenienceFee",
		// 		"Amount": this.workingInvoice.FeeAmount,
		// 		"Qty": 1
		// 	});
		// }
	}
}
